module.exports = __webpack_public_path__ + "static/media/vl2.5e86bc37.jpeg";